// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Filter buttons group */
.filter-buttons {
  display: flex;
  align-items: center;
  gap: 0;
  border-radius: var(--radius-md);
  border: 1px solid var(--color-border-default);
  background: var(--color-bg-surface);
  overflow: hidden;
}

.filter-buttons .btn--secondary {
  border: none;
  border-right: 1px solid var(--color-border-default);
  border-radius: 0;
  background: transparent;
}

.filter-buttons .btn--secondary:last-child {
  border-right: none;
}

.filter-buttons .btn--secondary:hover {
  background: var(--color-bg-hover);
}

.filter-buttons .btn--active {
  background: var(--color-primary-light);
  color: var(--color-primary);
  font-weight: var(--font-weight-semibold);
}

.filter-buttons .btn--active .btn__icon {
  filter: brightness(0) saturate(100%) invert(27%) sepia(91%) saturate(1232%)
    hue-rotate(201deg) brightness(102%) contrast(97%);
}
`, "",{"version":3,"sources":["webpack://./src/styles/components/filter-buttons.css"],"names":[],"mappings":"AAAA,yBAAyB;AACzB;EACE,aAAa;EACb,mBAAmB;EACnB,MAAM;EACN,+BAA+B;EAC/B,6CAA6C;EAC7C,mCAAmC;EACnC,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,mDAAmD;EACnD,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,sCAAsC;EACtC,2BAA2B;EAC3B,wCAAwC;AAC1C;;AAEA;EACE;qDACmD;AACrD","sourcesContent":["/* Filter buttons group */\n.filter-buttons {\n  display: flex;\n  align-items: center;\n  gap: 0;\n  border-radius: var(--radius-md);\n  border: 1px solid var(--color-border-default);\n  background: var(--color-bg-surface);\n  overflow: hidden;\n}\n\n.filter-buttons .btn--secondary {\n  border: none;\n  border-right: 1px solid var(--color-border-default);\n  border-radius: 0;\n  background: transparent;\n}\n\n.filter-buttons .btn--secondary:last-child {\n  border-right: none;\n}\n\n.filter-buttons .btn--secondary:hover {\n  background: var(--color-bg-hover);\n}\n\n.filter-buttons .btn--active {\n  background: var(--color-primary-light);\n  color: var(--color-primary);\n  font-weight: var(--font-weight-semibold);\n}\n\n.filter-buttons .btn--active .btn__icon {\n  filter: brightness(0) saturate(100%) invert(27%) sepia(91%) saturate(1232%)\n    hue-rotate(201deg) brightness(102%) contrast(97%);\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
